<template>
  <div class="card">
    <!-- <button @click="test">holi</button> -->
    <div class="card-header bg-success rounded-top">
      <p class="text-light font-weight-bold w-25">EDITOR DE MEMBRESÍAS</p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-4 d-flex flex-column">
          <label
            for=""
            class="text-uppercase my-auto text-secondary font-weight-bold"
            >Establecer Estado</label
          >
          <el-select size="small" class="mx-auto my-auto" v-model="status">
            <el-option value="" label="No Editar"></el-option>
            <el-option
              v-for="(cat, i) in catalogDictionary.status"
              :key="i"
              :value="cat"
              :label="cat"
            ></el-option>
            <!-- <el-option value="VIGENTE" label="VIGENTE"></el-option>
            <el-option value="PAGADO" label="PAGADO"></el-option>
            <el-option value="CONGELADO" label="CONGELADO"></el-option>
            <el-option value="PENDIENTE" label="PENDIENTE"></el-option> -->
          </el-select>
        </div>
        <div class="col-4 d-flex flex-column">
          <label
            for=""
            class="text-uppercase my-auto text-secondary font-weight-bold"
            >Cambiar Turno</label
          >
          <div class="d-flex my-auto">
            <div class="col-3">
              <p-switch
                class="my-auto"
                v-model="editShift"
                type="primary"
              ></p-switch>
            </div>
            <el-tooltip
              :open-delay="200"
              placement="top"
              :disabled="!editShift"
            >
              <template #content>
                {{ shiftName }}
              </template>
              <div
                class="my-auto mx-auto col-8 shiftname-container text-center d-flex py-1"
                @click="editSelectedShift"
              >
                <span class="col my-auto text-truncate">{{
                  !shiftName || !editShift ? "No Editar" : shiftName
                }}</span>
                <i
                  class="my-auto fa fa-pencil ml-auto mr-0 fa-lg"
                  aria-hidden="true"
                ></i></div
            ></el-tooltip>
          </div>
        </div>
        <div class="col-4 d-flex flex-column">
          <label for="" class="text-uppercase text-secondary font-weight-bold"
            >Cambiar Plan</label
          >
          <button class="btn btn-danger my-auto rounded-pill mx-auto" disabled>
            REASIGNAR MEMBRESÍAS
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <hr />
      <div class="row mt-4">
        <div class="col-4 d-flex flex-column">
          <label for="" class="text-uppercase text-secondary font-weight-bold"
            >Ajustar Fechas</label
          >
          <el-select class="mx-auto" v-model="editDates" size="small">
            <el-option default value="" label="No Editar"></el-option>
            <el-option value="addSub" label="Añadir/Restar días"></el-option>
            <el-option
              value="set"
              label="Establecer Fecha Uniforme"
            ></el-option>
          </el-select>
          <template v-if="editDates">
            <label for="" class="border-bottom mt-2 w-50"
              >Fecha de Inicio</label
            >

            <div v-if="editDates === 'addSub'" class="w-100 d-flex my-4">
              <div class="col-4">
                <p-radio label="day" v-model="planDates.startDateUnit"
                  >Días</p-radio
                >
                <p-radio label="month" v-model="planDates.startDateUnit"
                  >Meses</p-radio
                >
              </div>
              <div class="col-8 d-flex">
                <button
                  class="w-auto btn btn-danger px-2 py-1 my-auto"
                  @click="planDates.startDate--"
                >
                  <i class="fa fa-minus fa-2x" aria-hidden="true"></i>
                </button>
                <input
                  type="number"
                  class="number-container d-flex mx-2 text-center lead my-auto"
                  v-model="planDates.startDate"
                />
                <button
                  class="w-auto btn btn-success px-2 py-1 my-auto"
                  @click="planDates.startDate++"
                >
                  <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div v-else-if="editDates === 'set'" class="d-flex flex-row py-1">
              <div class="col-3">
                <p-checkbox size="small" class="my-auto" v-model="setStartDate"
                  >Editar</p-checkbox
                >
              </div>
              <div class="col-8 my-auto pl-4">
                <el-date-picker
                  type="date"
                  v-model="planDates.newStartDate"
                  class="w-auto my-auto"
                  size="small"
                  value-format="dd-MM-yyyy"
                  format="dd-MM-yyyy"
                  :disabled="!setStartDate"
                ></el-date-picker>
              </div>
            </div>

            <label for="" class="border-bottom mt-2 w-50 text-nowrap"
              >Fecha de Vencimiento</label
            >
            <div v-if="editDates === 'addSub'" class="w-100 d-flex my-4">
              <div class="col-4">
                <p-radio label="day" v-model="planDates.dueDateUnit"
                  >Dias</p-radio
                >
                <p-radio label="month" v-model="planDates.dueDateUnit"
                  >Meses</p-radio
                >
              </div>
              <div class="col-8 d-flex">
                <button
                  class="w-auto btn btn-danger px-2 py-1 my-auto"
                  @click="planDates.dueDate--"
                >
                  <i class="fa fa-minus fa-2x" aria-hidden="true"></i>
                </button>
                <input
                  type="number"
                  class="number-container my-auto d-flex mx-2 text-center lead"
                  v-model="planDates.dueDate"
                />
                <button
                  class="w-auto btn btn-success px-2 py-1 my-auto"
                  @click="planDates.dueDate++"
                >
                  <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div v-else-if="editDates === 'set'" class="d-flex flex-row py-1">
              <div class="col-3 my-auto">
                <p-checkbox class="my-auto" v-model="setDueDate"
                  >Editar</p-checkbox
                >
              </div>
              <div class="col-8 my-auto pl-4">
                <el-date-picker
                  type="date"
                  class="w-auto my-auto"
                  size="small"
                  value-format="dd-MM-yyyy"
                  format="dd-MM-yyyy"
                  :disabled="!setDueDate"
                  v-model="planDates.newDueDate"
                ></el-date-picker>
              </div>
            </div>
          </template>
          <div class="w-100 border-bottom mt-3 mx-auto"></div>
          <label
            for=""
            class="text-uppercase text-secondary font-weight-bold mt-2"
            >Modificar Duración</label
          >
          <el-select class="mx-auto" v-model="editExtension" size="small">
            <el-option default value="" label="No Editar"></el-option>
            <el-option value="set" label="Modificar"></el-option>
          </el-select>
          <div v-if="editExtension === 'set'" class="d-flex flex-row py-1">
            <div class="col-3">
              <p-radio
                v-for="(cat, i) in catalogDictionary.duration"
                :key="i"
                v-model="planExtension.unit"
                :label="cat"
                class="pb-0 mb-0"
                >{{ cat.split(" ")[0] }}</p-radio
              >
            </div>
            <div class="col-8 d-flex">
              <fg-input
                type="number"
                name=""
                offClass="bg-dark"
                size="small"
                id=""
                v-model="planExtension.amount"
                class="mx-auto mb-0 mt-auto"
              ></fg-input>
            </div>
          </div>
        </div>

        <div class="col-4 d-flex flex-column border-right border-left">
          <label for="" class="text-uppercase text-secondary font-weight-bold"
            >Ajustar Valor</label
          >
          <el-select class="mx-auto" v-model="editPrice" size="small">
            <el-option default value="" label="No Editar"></el-option>
            <el-option value="addSub" label="Ajustar Precio Actual"></el-option>
            <el-option
              value="set"
              label="Establecer Precio Uniforme"
            ></el-option>
          </el-select>
          <template v-if="editPrice">
            <label for="" class="border-bottom mt-2 w-50">{{
              editPrice === "addSub" ? `Reajuste` : `Nuevo Precio`
            }}</label>
            <template v-if="editPrice === 'addSub'">
              <div class="w-100 d-flex justify-content-around mt-2">
                <p-radio v-model="priceEditType" label="amount"
                  >Monto Fijo $</p-radio
                >
                <p-radio v-model="priceEditType" label="percentage"
                  >Porcentaje %</p-radio
                >
              </div>
              <div class="w-100 d-flex flex-row justify-content-center">
                <div class="d-flex text-center flex-column mr-3 my-auto">
                  <label for="" class="mb-0">Operador</label>
                  <p-switch size="small" type="info" v-model="editPriceAdd"
                    ><i class="fa fa-plus" slot="on"></i>
                    <i class="fa fa-minus text-info" type="info" slot="off"></i
                  ></p-switch>
                </div>
                <fg-input
                  type="number"
                  name=""
                  offClass="bg-dark"
                  size="small"
                  id=""
                  v-model="price.priceAdjustment"
                  class="w-50 my-auto"
                  :addon-left-icon="
                    priceEditType === 'amount' ? 'fa fa-usd' : 'fa fa-percent'
                  "
                ></fg-input>
              </div>
              <div v-if="priceEditType === 'percentage'" class="w-100">
                <p-checkbox v-model="aproxResults"
                  >Redondear Resultado</p-checkbox
                >
              </div>
            </template>
            <template v-else>
              <fg-input
                type="number"
                name=""
                size="small"
                id=""
                v-model="price.newPrice"
                class="w-75 mx-auto mt-4"
                addon-left-icon="fa fa-usd"
              ></fg-input>
            </template>
          </template>
        </div>

        <div class="col-4 d-flex flex-column">
          <label for="" class="text-uppercase text-secondary font-weight-bold"
            >Ajustar Sesiones</label
          >
          <el-select class="mx-auto" v-model="editSessions" size="small">
            <el-option default value="" label="No Editar"></el-option>
            <el-option
              value="addSub"
              label="Añadir/Restar Sesiones"
            ></el-option>
            <el-option
              value="set"
              label="Establecer Cantidad Uniforme"
            ></el-option>
          </el-select>
          <template v-if="editSessions">
            <div class="d-flex flex-row py-2">
              <div class="col my-auto">
                <p-checkbox class="mb-0" v-model="sessions.activateSessions"
                  >Forzar uso de sesiones</p-checkbox
                >
              </div>
            </div>
            <label for="" class="border-bottom mt-2 w-50"
              >Sesiones Utilizadas</label
            >

            <div
              v-if="editSessions === 'addSub'"
              class="w-100 d-flex justify-content-center my-4"
            >
              <button
                class="w-auto btn btn-danger px-2 py-1 my-auto"
                @click="sessions.usedAdjustment--"
              >
                <i class="fa fa-minus fa-2x" aria-hidden="true"></i>
              </button>
              <input
                type="number"
                class="number-container d-flex mx-2 text-center lead"
                v-model="sessions.usedAdjustment"
              />
              <button
                class="w-auto btn btn-success px-2 py-1 my-auto"
                @click="sessions.usedAdjustment++"
              >
                <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
              </button>
            </div>
            <div
              v-else-if="editSessions === 'set'"
              class="d-flex flex-row py-2"
            >
              <div class="col-4 my-auto">
                <p-checkbox class="mb-0" v-model="setUsedSessions"
                  >Editar</p-checkbox
                >
              </div>
              <div class="col-8">
                <input
                  class="form-control col-10 mx-auto"
                  type="number"
                  v-model="sessions.newUsed"
                  :disabled="!setUsedSessions"
                />
              </div>
            </div>
            <label for="" class="border-bottom mt-2 w-50"
              >Sesiones Totales</label
            >
            <div
              v-if="editSessions === 'addSub'"
              class="w-100 d-flex justify-content-center my-4"
            >
              <button
                class="w-auto btn btn-danger px-2 py-1 my-auto"
                @click="sessions.totalAdjustment--"
              >
                <i class="fa fa-minus fa-2x" aria-hidden="true"></i>
              </button>
              <input
                type="number"
                class="number-container d-flex mx-2 text-center lead"
                v-model="sessions.totalAdjustment"
              />
              <button
                class="w-auto btn btn-success px-2 py-1 my-auto"
                @click="sessions.totalAdjustment++"
              >
                <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
              </button>
            </div>
            <div
              v-else-if="editSessions === 'set'"
              class="d-flex flex-row py-2"
            >
              <div class="col-4 my-auto">
                <p-checkbox class="mb-0" v-model="setSessionsTotal"
                  >Editar</p-checkbox
                >
              </div>
              <div class="col-8">
                <input
                  class="form-control col-10 mx-auto"
                  type="number"
                  v-model="sessions.newTotal"
                  :disabled="!setSessionsTotal"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex justify-content-center">
      <button
        class="btn-info btn col-auto rounded-pill mt-0 ml-4 shadow-sm"
        @click="handleContinue"
        :disabled="!wasModified"
      >
        continuar
        <i class="fa fa-arrow-down fa-lg" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>

<script>
import PSwitch from "src/components/UIComponents/Switch.vue";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
export default {
  name: "membershipEditor",
  components: {
    PSwitch,
    [DatePicker.name]: DatePicker,
    [Tooltip.name]: Tooltip,
  },
  props: {
    editShiftProp: {
      type: Boolean,
      default: false,
    },
    shiftName: {
      type: String,
      default: "",
    },
    catalogDictionary: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      aproxResults: true,
      editDates: "",
      editPrice: "",
      editSessions: "",
      editExtension: "",
      setUsedSessions: false,
      setSessionsTotal: false,
      setStartDate: false,
      setDueDate: false,
      editPriceAdd: true,
      priceEditType: "amount",
      editShift: false,
      editPlan: false,
      num: 0,
      status: "",
      price: {
        newPrice: 0,
        priceAdjustment: 0,
      },
      planDates: {
        newStartDate: "",
        startDate: 0,
        startDateUnit: "day",
        newDueDate: "",
        dueDate: 0,
        dueDateUnit: "day",
      },
      planExtension: {
        amount: 0,
        unit: "",
      },
      sessions: {
        newUsed: 0,
        usedAdjustment: 0,
        newTotal: 0,
        totalAdjustment: 0,
        activateSessions: false,
      },
      wasModified: false,
    };
  },
  watch: {
    wasModified: function (val) {
      if (val) {
        this.$emit("updated");
      }
    },
    editPriceAdd: function (val) {
      this.wasModified = true;
    },
    priceEditType: function (val) {
      this.wasModified = true;
      this.aproxResults = true;
    },
    aproxResults: function (val) {
      this.wasModified = true;
    },
    sessions: {
      handler(val) {
        this.wasModified = true;
      },
      deep: true,
    },
    planDates: {
      handler(val) {
        this.wasModified = true;
      },
      deep: true,
    },
    planExtension: {
      handler(val) {
        this.wasModified = true;
      },
      deep: true,
    },
    price: {
      handler(val) {
        this.wasModified = true;
      },
      deep: true,
    },
    status: function (val) {
      this.wasModified = true;
    },
    setStartDate: function (val) {
      this.wasModified = true;
      this.planDates.newStartDate = val
        ? this.$moment().format("DD-MM-YYYY")
        : "";
    },
    setDueDate: function (val) {
      this.wasModified = true;
      this.planDates.newDueDate = val
        ? this.$moment().format("DD-MM-YYYY")
        : "";
    },
    editExtension: function (newValue) {
      this.wasModified = true;
      this.planExtension.amount = 0;
      this.planExtension.unit = "";
    },
    editShift: function (newValue) {
      this.wasModified = true;
      this.$emit("toggleShiftSelect", newValue);
    },
    editSessions: function (val) {
      this.wasModified = true;
      this.sessions = {
        newUsed: 0,
        usedAdjustment: 0,
        newTotal: 0,
        totalAdjustment: 0,
      };
      this.setUsedSessions = false;
      this.setSessionsTotal = false;
    },
    editDates: function (val) {
      this.wasModified = true;
      this.planDates = {
        newStartDate: "",
        startDate: 0,
        startDateUnit: "day",
        newDueDate: "",
        dueDate: 0,
        dueDateUnit: "day",
      };
      if (val === "set") {
      }
    },
    editPrice: function (val) {
      this.wasModified = true;
      this.price = {
        newPrice: 0,
        priceAdjustment: 0,
      };
      this.priceEditType = "amount";
    },
    "planDates.newStartDate": function (newValue) {
      if (!newValue && this.editDates === "set" && this.setStartDate) {
        this.planDates.newStartDate = "01-01-1900";
      }
    },
    "planDates.newDueDate": function (newValue) {
      if (!newValue && this.editDates === "set" && this.setDueDate) {
        this.planDates.newDueDate = "01-01-1900";
      }
    },
    "planDates.startDate": function (newValue) {
      if (isNaN(newValue)) {
        this.planDates.startDate = parseInt(0);
      } else {
        this.planDates.startDate = parseInt(newValue);
      }
    },
    "planDates.dueDate": function (newValue) {
      if (isNaN(newValue)) {
        this.planDates.dueDate = parseInt(0);
      } else {
        this.planDates.dueDate = parseInt(newValue);
      }
    },
    "price.priceAdjustment": function (newValue) {
      if (isNaN(newValue) || parseInt(newValue) < 0) {
        this.price.priceAdjustment = 0;
      } else {
        this.price.priceAdjustment = parseInt(newValue);
      }
    },
    "price.newPrice": function (newValue) {
      if (isNaN(newValue) || parseFloat(newValue) < 0) {
        this.price.newPrice = 0;
      } else {
        this.price.newPrice = parseFloat(newValue);
      }
    },
    "sessions.usedAdjustment": function (newValue) {
      if (isNaN(newValue)) {
        this.sessions.usedAdjustment = parseInt(0);
      } else {
        this.sessions.usedAdjustment = parseInt(newValue);
      }
    },
    "sessions.totalAdjustment": function (newValue) {
      if (isNaN(newValue)) {
        this.sessions.totalAdjustment = parseInt(0);
      } else {
        this.sessions.totalAdjustment = parseInt(newValue);
      }
    },
    "sessions.newUsed": function (newValue) {
      if (isNaN(newValue) || parseFloat(newValue) < 0) {
        this.sessions.newUsed = 0;
      } else {
        this.sessions.newUsed = parseFloat(newValue);
      }
    },
    "sessions.newTotal": function (newValue) {
      if (isNaN(newValue) || parseFloat(newValue) < 0) {
        this.sessions.newTotal = 0;
      } else {
        this.sessions.newTotal = parseFloat(newValue);
      }
    },
    "planExtension.amount": function (newValue) {
      if (isNaN(newValue) || parseFloat(newValue) < 0) {
        this.planExtension.amount = 0;
      } else {
        this.planExtension.amount = parseFloat(newValue);
      }
    },
  },
  methods: {
    test() {
      console.log(this.catalogDictionary);
    },
    toggleWasModified(val) {
      this.wasModified = !!val;
    },
    clean() {
      this.editDates = "";
      this.editPrice = "";
      this.editSessions = "";
      this.editExtension = "";
      this.setUsedSessions = false;
      this.setSessionsTotal = false;
      this.editPriceAdd = true;
      this.priceEditType = "amount";
      this.editShift = false;
      this.editPlan = false;
      this.num = 0;
      this.status = "";
      this.price = {
        newPrice: 0,
        priceAdjustment: 0,
      };
      this.planDates = {
        newStartDate: "",
        startDate: 0,
        startDateUnit: "day",
        newDueDate: "",
        dueDate: 0,
        dueDateUnit: "day",
      };
      this.sessions = {
        newUsed: 0,
        usedAdjustment: 0,
        newTotal: 0,
        totalAdjustment: 0,
      };
      this["planExtension.amount"] = 0;
      this["planExtension.unit"] = "";
    },
    editShiftClose() {
      this.editShift = false;
    },
    editSelectedShift() {
      if (this.editShift) {
        this.$emit("editSelectedShift");
      } else {
        return;
      }
    },
    handleContinue() {
      let result = {};
      if (this.status) {
        result.status = this.status;
      }
      if (this.editPrice) {
        switch (this.editPrice) {
          case "addSub":
            result.editPrice = "adjust"; // Sumar/Restar del valor actual
            result.priceEditType = this.priceEditType;
            if (result.priceEditType === "amount") {
              result.newPrice = this.editPriceAdd
                ? this.price.priceAdjustment
                : this.price.priceAdjustment * -1;
            } else {
              result.newPrice = this.editPriceAdd
                ? this.price.priceAdjustment / 100 + 1
                : (100 - this.price.priceAdjustment) / 100;
              result.aproxResults = this.aproxResults;
            }
            break;
          case "set":
            result.editPrice = "set"; // Define un nuevo valor
            result.newPrice = this.price.newPrice;
            break;

          default:
            break;
        }
      }
      if (this.editSessions) {
        var edit = {};
        switch (this.editSessions) {
          case "addSub":
            edit.usedAdjustment = parseInt(this.sessions.usedAdjustment);
            edit.totalAdjustment = parseInt(this.sessions.totalAdjustment);
            break;
          case "set":
            if (this.setUsedSessions) {
              edit.newUsed = parseInt(this.sessions.newUsed);
            }
            if (this.setSessionsTotal) {
              edit.newTotal = parseInt(this.sessions.newTotal);
            }
            break;
          default:
            break;
        }
        if (this.sessions.activateSessions === true) {
          edit.activateSessions = true;
        }
        if (edit) {
          result.sessions = edit;
        }
      }
      if (this.editDates) {
        var edit = {};
        switch (this.editDates) {
          case "addSub":
            edit.startDate = parseInt(this.planDates.startDate);
            edit.startDateUnit = this.planDates.startDateUnit;
            edit.dueDate = parseInt(this.planDates.dueDate);
            edit.dueDateUnit = this.planDates.dueDateUnit;
            break;
          case "set":
            if (this.planDates.newStartDate) {
              edit.newStartDate = this.planDates.newStartDate;
            }
            if (this.planDates.newDueDate) {
              edit.newDueDate = this.planDates.newDueDate;
            }
            break;
          default:
            break;
        }
        if (edit) {
          result.planDates = edit;
        }
      }
      if (this.editExtension) {
        result.planExtension = {
          amount: parseInt(this.planExtension.amount),
          unit: this.planExtension.unit,
        };
      }
      this.wasModified = false;
      // console.log(this.editShift);
      // console.log(result);
      this.$emit("continue", result, this.editShift);
    },
  },
};
</script>

<style>
.number-container {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 1px 3px #343a409a inset;
}
.shiftname-container {
  border-radius: 4px;
  border: none;
  box-shadow: 0px 1px 3px #343a409a inset;
}
.shiftname-container:hover {
  cursor: pointer;
}
</style>
